import { render } from "./DEntryPostSaveOptions.vue?vue&type=template&id=0272fbf6&lang=pug"
import script from "./DEntryPostSaveOptions.vue?vue&type=script&lang=js"
export * from "./DEntryPostSaveOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__